import React  from "react"; //{ useState }
import PropTypes from "prop-types";
import {
  Box,
  InputBase,
  IconButton,
  Tooltip,
  // Popover,
  // Stack,
  // Switch,
  Typography,
  // Divider,
} from "@mui/material";
import GraphicEqIcon from "@mui/icons-material/GraphicEq";
import StopIcon from "@mui/icons-material/Stop";
// import TuneIcon from "@mui/icons-material/Tune";
// import BarChartRoundedIcon from "@mui/icons-material/BarChartRounded";
// import TableChartRoundedIcon from "@mui/icons-material/TableChartRounded";

const ChatInput = ({
  input,
  setInput,
  onSendMessage,
  onCancel,
  isLoading,
  visualizationOptions = { chart: true, table: true },
  onVisualizationChange = () => {},
  showVisualizationOptions = true,
  activeResearchMode = "",
  activeResearchSources = "",
}) => {
  // const [popupAnchorEl, setPopupAnchorEl] = useState(null);

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey && (input?.trim?.() || "")) {
      e.preventDefault();
      onSendMessage();
    }
  };

  // const isPopupOpen = Boolean(popupAnchorEl);

  return (
    <Box
      sx={{
        padding: "0 10px 10px 10px",
        zIndex: 1,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        transition: "all 0.3s ease",
        boxSizing: "border-box",
      }}
    >
      {/* Pill container */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          width: "100%",
          maxWidth: "860px",
          backgroundColor: "#fff",
          borderRadius: "20px",
          border: "1px solid #E2E8F0",
          boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
          padding: "6px 6px 6px 4px",
          gap: 0.5,
        }}
      >
        {/* Text input */}
        <Box sx={{ flex: 1, minWidth: 0, ml: 1, px: 1, py: 0.2 }}>
          <InputBase
            fullWidth
            multiline
            minRows={1}
            maxRows={5}
            placeholder={isLoading ? "Generating response…" : "Ask Anything"}
            id="inputtext"
            value={input}
            onChange={(e) => setInput(e.target.value)}
            onKeyDown={handleKeyDown}
            disabled={isLoading}
            sx={{
              fontFamily: "'Poppins', sans-serif",
              fontSize: "0.95rem",
              color: "#1B2559",
              width: "100%",
              alignSelf: "stretch",
              "& textarea": {
                lineHeight: 1.45,
                paddingTop: "7px",
                paddingBottom: "7px",
                resize: "none",
              },
              "& textarea::placeholder": {
                color: "#A0AEC0",
                opacity: 1,
              },
            }}
          />
        </Box>

        {/* {showVisualizationOptions && (
          <>
            <Tooltip title="Visualization options" placement="top">
              <IconButton
                onClick={(event) => setPopupAnchorEl(event.currentTarget)}
                disabled={isLoading}
                sx={{
                  width: 36,
                  height: 36,
                  mr: 0.5,
                  color: "#334155",
                  border: "1px solid #CBD5E1",
                  backgroundColor: "#F8FAFC",
                  "&:hover": { backgroundColor: "#EEF2FF" },
                }}
              >
                <TuneIcon sx={{ fontSize: 18 }} />
              </IconButton>
            </Tooltip>

            <Popover
              open={isPopupOpen}
              anchorEl={popupAnchorEl}
              onClose={() => setPopupAnchorEl(null)}
              anchorOrigin={{ vertical: "top", horizontal: "center" }}
              transformOrigin={{ vertical: "bottom", horizontal: "center" }}
              sx={{
                "& .MuiPopover-paper": {
                  transform: "translateY(-10px) !important",
                },
              }}
              slotProps={{
                paper: {
                  sx: {
                    p: 0,
                    borderRadius: "14px",
                    border: "1px solid #DBE4F2",
                    boxShadow: "0 18px 34px rgba(15, 23, 42, 0.16)",
                    minWidth: 310,
                    overflow: "visible",
                    background: "linear-gradient(180deg, #FFFFFF 0%, #F8FBFF 100%)",
                    "&::after": {
                      content: '""',
                      position: "absolute",
                      bottom: -7,
                      left: "calc(50% - 7px)",
                      width: 14,
                      height: 14,
                      backgroundColor: "#ffffff",
                      borderRight: "1px solid #E2E8F0",
                      borderBottom: "1px solid #E2E8F0",
                      transform: "rotate(45deg)",
                      zIndex: 0,
                    },
                  },
                },
              }}
            >
              <Stack spacing={0}>
                <Box sx={{ px: 1.7, py: 1.4 }}>
                  <Typography
                    variant="subtitle2"
                    sx={{
                      fontFamily: "'Poppins', sans-serif",
                      color: "#0F1F52",
                      fontWeight: 700,
                      fontSize: "0.9rem",
                      letterSpacing: "0.01em",
                    }}
                  >
                    Visualization Preferences
                  </Typography>
                  <Typography
                    sx={{
                      fontFamily: "'Poppins', sans-serif",
                      color: "#5A6B93",
                      fontWeight: 500,
                      fontSize: "0.74rem",
                      mt: 0.4,
                    }}
                  >
                    Control how responses are rendered by default.
                  </Typography>
                </Box>

                <Divider sx={{ borderColor: "#E7EDF8" }} />

                <Stack spacing={1} sx={{ p: 1.2 }}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      gap: 1,
                      p: 1.1,
                      borderRadius: "10px",
                      border: "1px solid #DCE6F5",
                      backgroundColor: Boolean(visualizationOptions?.chart) ? "#F3F7FF" : "#FFFFFF",
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <Box
                        sx={{
                          width: 26,
                          height: 26,
                          borderRadius: "8px",
                          display: "grid",
                          placeItems: "center",
                          backgroundColor: "#E7EEFF",
                          color: "#2043A8",
                        }}
                      >
                        <BarChartRoundedIcon sx={{ fontSize: 16 }} />
                      </Box>
                      <Box>
                        <Typography
                          sx={{
                            fontFamily: "'Poppins', sans-serif",
                            fontSize: "0.82rem",
                            fontWeight: 600,
                            color: "#233457",
                            lineHeight: 1.2,
                          }}
                        >
                          Chart Generation
                        </Typography>
                        <Typography
                          sx={{
                            fontFamily: "'Poppins', sans-serif",
                            fontSize: "0.7rem",
                            fontWeight: 500,
                            color: "#6A7A9E",
                            mt: 0.2,
                          }}
                        >
                          Generate chart-ready output.
                        </Typography>
                      </Box>
                    </Box>
                    <Switch
                      size="small"
                      checked={Boolean(visualizationOptions?.chart)}
                      onChange={(event) =>
                        onVisualizationChange({
                          chart: event.target.checked,
                          table: Boolean(visualizationOptions?.table),
                        })
                      }
                    />
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      gap: 1,
                      p: 1.1,
                      borderRadius: "10px",
                      border: "1px solid #DCE6F5",
                      backgroundColor: Boolean(visualizationOptions?.table) ? "#F3F7FF" : "#FFFFFF",
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <Box
                        sx={{
                          width: 26,
                          height: 26,
                          borderRadius: "8px",
                          display: "grid",
                          placeItems: "center",
                          backgroundColor: "#E7EEFF",
                          color: "#2043A8",
                        }}
                      >
                        <TableChartRoundedIcon sx={{ fontSize: 16 }} />
                      </Box>
                      <Box>
                        <Typography
                          sx={{
                            fontFamily: "'Poppins', sans-serif",
                            fontSize: "0.82rem",
                            fontWeight: 600,
                            color: "#233457",
                            lineHeight: 1.2,
                          }}
                        >
                          Table View Generation
                        </Typography>
                        <Typography
                          sx={{
                            fontFamily: "'Poppins', sans-serif",
                            fontSize: "0.7rem",
                            fontWeight: 500,
                            color: "#6A7A9E",
                            mt: 0.2,
                          }}
                        >
                          Return a tabular response.
                        </Typography>
                      </Box>
                    </Box>
                    <Switch
                      size="small"
                      checked={Boolean(visualizationOptions?.table)}
                      onChange={(event) =>
                        onVisualizationChange({
                          chart: Boolean(visualizationOptions?.chart),
                          table: event.target.checked,
                        })
                      }
                    />
                  </Box>
                </Stack>

                <Box sx={{ px: 1.5, pb: 1.2 }}>
                  <Typography
                    sx={{
                      fontFamily: "'Poppins', sans-serif",
                      fontSize: "0.68rem",
                      color: "#7585AA",
                      textAlign: "center",
                    }}
                  >
                    These preferences are applied to your next query.
                  </Typography>
                </Box>
              </Stack>
            </Popover>
          </>
        )} */}

        {/* Send / Cancel button */}
        <Tooltip title={isLoading ? "Cancel request" : "Send message"} placement="top">
          <IconButton
            onClick={isLoading ? onCancel : onSendMessage}
            sx={{
              backgroundColor: isLoading ? "#d32f2f" : "#111827",
              color: "#fff",
              width: 40,
              height: 40,
              borderRadius: "50%",
              flexShrink: 0,
              "&:hover": {
                backgroundColor: isLoading ? "#b71c1c" : "#374151",
              },
              transition: "background-color 0.2s ease",
            }}
          >
            {isLoading ? (
              <StopIcon sx={{ fontSize: 20 }} />
            ) : (
              <GraphicEqIcon sx={{ fontSize: 20 }} />
            )}
          </IconButton>
        </Tooltip>
      </Box>

      {activeResearchMode && (
        <Typography
          sx={{
            width: "100%",
            maxWidth: "860px",
            mt: 0.6,
            px: 1.5,
            fontFamily: "'Poppins', sans-serif",
            fontSize: "0.72rem",
            color: "#64748B",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            textAlign: "center",
          }}
        >
          <span dangerouslySetInnerHTML={{ __html: `<b>Active Research Mode:</b> ${activeResearchMode}${activeResearchSources ? ` | <b>Sources:</b> ${activeResearchSources}` : ""}` }} />
        </Typography>
      )}
    </Box>
  );
};

ChatInput.propTypes = {
  input: PropTypes.string.isRequired,
  setInput: PropTypes.func.isRequired,
  onSendMessage: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  visualizationOptions: PropTypes.shape({
    chart: PropTypes.bool,
    table: PropTypes.bool,
  }),
  onVisualizationChange: PropTypes.func,
  showVisualizationOptions: PropTypes.bool,
  activeResearchMode: PropTypes.string,
  activeResearchSources: PropTypes.string,
};

export default ChatInput;

